import { Dialog, DialogContent, Stack } from "@mui/material";
import { APP_STORE_APPLE_LINK, APP_STORE_GOOGLE_LINK } from "app/appConstants";
import { MprcDialogTitleClose, MprcRequestErrorReport, MprcSpinnerIndicator } from "components";
import { CreateTokenAccessResponse } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import { useSession } from "providers/SessionProvider";
import { QRCodeSVG } from "qrcode.react";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { SessionService } from "services/sessionService";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onClose: () => void;
}

export const QrCodeAccess = ({ onClose }: IProps) => {

    const { t } = useTranslation();
    const api = useCoreApi();
    const { user } = useSession();
    const [viewError, setViewError] = useState<any>(null);
    const [viewData, setViewData] = useState<CreateTokenAccessResponse>(null!);
    const [loading, setLoading] = useState(true);
    const apiUrl = SessionService.current.apiPaths.coreApi;
    const location = window.location;
    const hostname = location.host.split(":")[0];

    ///
    const load = async () => {
        try {
            var response = await api.v1.account.createTokenAccess({ userId: user.userId });
            setViewData(response.data);
        }
        catch (e) {
            setViewError(e);
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
        const refreshCodeInterval = setInterval(load, 180000);
        return () => {
            clearInterval(refreshCodeInterval);
        };
    }, []);

    return (
        <Dialog open onClose={onClose}>
            <MprcDialogTitleClose onClose={onClose} title={t("Auth.QrCode.Title")} />
            <DialogContent>
                {
                    viewError
                        ? <MprcRequestErrorReport error={viewError} />
                        : (
                            <>
                                <div style={{ textAlign: "center" }}>
                                    {
                                        loading
                                            ? <MprcSpinnerIndicator />
                                            : <>
                                                <QRCodeSVG value={`hostname=${hostname}&apiUrl=${apiUrl}&token=${viewData.token}`} size={384} />
                                            </>

                                    }
                                </div>
                                <ul>
                                    <li>{t("Auth.QrCode.L1")}</li>
                                    <li><Trans i18nKey="Auth.QrCode.L2" /></li>
                                    <li>{t("Auth.QrCode.L3")}</li>
                                    <li>{t("Auth.QrCode.L4")}</li>
                                </ul>
                                <Stack direction="row" justifyContent="center" alignItems="center">
                                    <a href={APP_STORE_APPLE_LINK} target="_blank" rel="noreferrer"><img src="/img/app/App-Store-Apple.png" /></a>
                                    <a href={APP_STORE_GOOGLE_LINK} target="_blank" rel="noreferrer"><img src="/img/app/App-Store-GooglePlay.png" /></a>
                                </Stack>
                            </>
                        )
                }
            </DialogContent>
        </Dialog>
    );
};
